/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PHBhdGggZD0iTTExLjQ4LDdoLTdsMy41LTZaTTYuMjYsNkg5Ljc1TDgsM1oiLz48cGF0aCBkPSJNNywxNWgtNlY5SDdabS01LTFINlYxMGgtNFoiLz48cGF0aCBkPSJNMTIsMTVhMywzLDAsMSwxLDMtM0EzLDMsMCwwLDEsMTIsMTVabTAtNWEyLDIsMCwxLDAsMiwyQTIsMiwwLDAsMCwxMiwxMFoiLz48L2c+PC9zdmc+";